import React, { useEffect } from 'react';
import IvoriMethodTmuaPage from '../../features/method/IvoriMethodTmuaPage';

export default function IvoriMethodTmuaRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Pólya, Lakatos & Cambridge Supervisions | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodTmuaPage />;
}